import { createContext, ReactNode, useCallback, useMemo, useState } from 'react';
import { Alert, AlertProps } from '../components/Alert';

type ProviderProps = {
  children: ReactNode;
};

type ContextProps = {
  show: (props: AlertProps) => void;
};

export const AlertContext = createContext({} as ContextProps);

export function AlertProvider({ children }: ProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [alertProps, setAlertProps] = useState({} as AlertProps);

  const close = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const show = useCallback(
    (props: AlertProps) => {
      setAlertProps(props);
      setIsOpen(true);
      setTimeout(() => {
        close();
      }, 10000);
    },
    [setIsOpen, setAlertProps, close],
  );
  const contextValue = useMemo(
    () => ({
      show,
    }),
    [show],
  );
  return (
    <AlertContext.Provider value={contextValue}>
      {children}
      <Alert {...{ isOpen, close, ...alertProps }} />
    </AlertContext.Provider>
  );
}
